"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const classnames_1 = __importDefault(require("classnames"));
const CarouselPagination = ({ selectedItemIndex, itemsNumber, onClick, }) => {
    return ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: "control-dots" }, { children: Array(itemsNumber)
            .fill(0)
            .map((_, index) => {
            const isSelected = index === selectedItemIndex;
            const key = `${_}${index}`;
            const ariaLabel = `image item ${index + 1}`;
            const dotClassName = (0, classnames_1.default)("dot", isSelected && "selected");
            return ((0, jsx_runtime_1.jsx)("button", { type: "button", onClick: onClick(index), className: dotClassName, "aria-label": ariaLabel }, key));
        }) })));
};
exports.default = CarouselPagination;
